export const name = "TIMESTAMP_DIFF";
export const summary = `Gets the number of unit boundaries between two \`TIMESTAMP\` values at a particular time granularity.`;
export const reference = `
## TIMESTAMP_DIFF

Gets the number of unit boundaries between two \`TIMESTAMP\` values at a particular time granularity.

\`\`\`
TIMESTAMP_DIFF(end_timestamp, start_timestamp, granularity)
\`\`\`

### Description

Gets the number of unit boundaries between two \`TIMESTAMP\` values (\`end_timestamp\` - \`start_timestamp\`) at a particular time granularity.


### Definitions

- \`start_timestamp\`: The starting \`TIMESTAMP\` value.
- \`end_timestamp\`: The ending \`TIMESTAMP\` value.
- \`granularity\`: The timestamp part that represents the granularity. If you passed in \`TIMESTAMP\` values for the first arguments, \`granularity\` can be:


### Details

If \`end_timestamp\` is earlier than \`start_timestamp\`, the output is negative. Produces an error if the computation overflows, such as if the difference in microseconds between the two \`TIMESTAMP\` values overflows.


### Note: The behavior of the this function follows the type of arguments passed in.
For example, TIMESTAMP_DIFF(DATE, DATE, PART)
behaves like DATE_DIFF(DATE, DATE, PART).




### Return Data Type

\`INT64\`


### Example



\`\`\`
SELECT
  TIMESTAMP("2010-07-07 10:20:00+00") AS later_timestamp,
  TIMESTAMP("2008-12-25 15:30:00+00") AS earlier_timestamp,
  TIMESTAMP_DIFF(TIMESTAMP "2010-07-07 10:20:00+00", TIMESTAMP "2008-12-25 15:30:00+00", HOUR) AS hours;

-- Display of results may differ, depending upon the environment and time zone where this query was executed.
/*-------------------------+-------------------------+-------*
 | later_timestamp | earlier_timestamp | hours |
 +-------------------------+-------------------------+-------+
 | 2010-07-07 10:20:00 UTC | 2008-12-25 15:30:00 UTC | 13410 |
 *-------------------------+-------------------------+-------*/
\`\`\`

In the following example, the first timestamp occurs before the second timestamp, resulting in a negative output.



\`\`\`
SELECT TIMESTAMP_DIFF(TIMESTAMP "2018-08-14", TIMESTAMP "2018-10-14", DAY) AS negative_diff;

/*---------------*
 | negative_diff |
 +---------------+
 | -61 |
 *---------------*/
\`\`\`

In this example, the result is 0 because only the number of whole specified\`HOUR\` intervals are included.



\`\`\`
SELECT TIMESTAMP_DIFF("2001-02-01 01:00:00", "2001-02-01 00:00:01", HOUR) AS diff;

/*---------------*
 | diff |
 +---------------+
 | 0 |
 *---------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
